<template>
  <section class="max-w-screen-xl mx-auto px-4 mb-20">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-6 max-w-7xl mx-auto">
      <!-- Left Sidebar -->
      <div class="lg:col-span-4 space-y-4">
        <NsCurrencySection />
        <NsAddToCartSection />
      </div>

      <!-- Center Content -->
      <div class="lg:col-span-4 space-y-4">
        <NsPayNow />
        <NsReview />
        <NsLangSection />
      </div>

      <!-- Right Sidebar -->
      <div class="lg:col-span-4 space-y-4">
        <NsShopNow />
        <NsProductCarousel />
        <NsSlider />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const NsSlider = defineAsyncComponent(() => import('~/components/productShowcaseSection/NsSlider.vue'))
const NsProductCarousel = defineAsyncComponent(() => import('~/components/productShowcaseSection/NsProductCarousel.vue'))
const NsShopNow = defineAsyncComponent(() => import('~/components/productShowcaseSection/NsShopNow.vue'))
const NsReview = defineAsyncComponent(() => import('~/components/productShowcaseSection/NsReview.vue'))
const NsPayNow = defineAsyncComponent(() => import('~/components/productShowcaseSection/NsPayNow.vue'))
const NsAddToCartSection = defineAsyncComponent(() => import('~/components/productShowcaseSection/NsAddToCartSection.vue'))
const NsCurrencySection = defineAsyncComponent(() => import('~/components/productShowcaseSection/NsCurrencySection.vue'))
const NsLangSection = defineAsyncComponent(() => import('~/components/productShowcaseSection/NsLangSection.vue'))
</script>
